import cx from "classnames";
import { CSSProperties, forwardRef, HTMLAttributes, memo, ReactNode } from "react";

import styles from "./styles.module.css";

type TableBodyRowProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  isActive?: boolean;
  dataIndex?: number;
  virtualized?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const TableBodyRow = memo(
  forwardRef<HTMLDivElement, TableBodyRowProps>(function TableBodyRow(
    { children, className, isActive, dataIndex, virtualized, ...props },
    ref
  ) {
    return (
      <div
        {...props}
        className={cx(styles.row, className, {
          [styles.active]: isActive,
          [styles.virtualized]: virtualized,
        })}
        role="row"
        tabIndex={-1}
        ref={ref}
        data-index={dataIndex}
      >
        {children}
      </div>
    );
  })
);

TableBodyRow.displayName = "DS.Table.Body.Row";

export default TableBodyRow;
